import type { QcsResourceSlice } from 'app-components/flux/core/resourceSliceUtils';
import z from 'zod';

const DocumentStatusSchema = z.enum(['PENDING', 'FAILED', 'COMPLETE']);
const DocumentSubStatusSchema = z
  .enum([
    'UPLOAD_PENDING',
    'UPLOAD_COMPLETE',
    'UPLOAD_FAILED',
    'UPLOAD_PROCESSING',
    'UPLOAD_EXPIRED',
    'THUMBNAIL_COMPLETE',
    'THUMBNAIL_FAILED',
    'FILE_LIMIT_EXCEEDED',
    'FILE_SIZE_EXCEEDED',
    'QUOTA_EXCEEDED',
    'MALWARE_SCAN_FAILED',
    'UNKNOWN', // if status is not one of the above, then unknown
  ])
  .default('UNKNOWN');

export const DocumentSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    status: DocumentStatusSchema,
    subStatus: DocumentSubStatusSchema,
    mimeType: z.string(),
    createdBy: z.string(),
    modifiedBy: z.string(),

    url: z.string(), // This is _not_ on the qcs record, but it is convenient to store it here
  })
  .partial();

export type DocumentType = z.infer<typeof DocumentSchema>;
export type CreateDocumentPayload = Pick<DocumentType, 'name' | 'mimeType'>;

export type StorageDomain = QcsResourceSlice<DocumentType>;
